import * as types from './actionTypes';
import Resource from "../services/PrivateAPIResource";

export function getContactPersonSuccess(contactPerson) {
    return {type: types.GET_CONTACT_PERSON_SUCCESS, contactPerson}
}

export function resetContactPerson() {
    return {type: types.RESET_CONTACT_PERSON}
}

export function getContactPerson(id) {
    return function (dispatch) {
        let promise = Resource.get('users', id);
        return promise.then(contactPerson => {
            dispatch(getContactPersonSuccess(contactPerson))
        }).catch(error => {
            throw  error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/contactPersonActions.js